var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isGlobalModalActive,
          expression: "isGlobalModalActive",
        },
      ],
      staticClass: "modal",
      attrs: { tabindex: "-1", role: "dialog", "aria-hidden": "true" },
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.hideGlobalModal.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-centered",
          style: {
            width: _vm.modalWidth,
          },
          attrs: { role: "document" },
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h3", { staticClass: "modal-title m-0" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.modalTitle) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _c("i", {
                staticClass: "fas fa-times-circle",
                on: { click: _vm.hideGlobalModal },
              }),
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "modal-body",
              domProps: { innerHTML: _vm._s(_vm.modalContent) },
            }),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }